import { TaskScopeNameEnum } from 'graphql-common';

export const CacheNames = {
  apiCalls: 'apiCalls',
  apiDB: 'apiDB',
  assets: 'assets',
  fonts: 'fonts',
  images: 'images',
  pages: 'pages',
  tasks: 'tasks',
  taskCompletions: 'taskCompletions',
};

export const Destinations = {
  font: 'font',
  image: 'image',
  script: 'script',
  style: 'style',
  worker: 'worker',
};

export enum CustomTaskScopeNameEnum {
  Downloads = 'DOWNLOADS',
  OnDemand = 'ON_DEMAND',
}

export type TaskScopeNameEnumExtended =
  | TaskScopeNameEnum
  | CustomTaskScopeNameEnum;
